class LoadImages extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.els.trigger?.element.addEventListener(
      'click',
      this.showImages.bind(this),
    )
  }

  showImages (e) {
    this.externalEls.image.elements.forEach((imageEl) => {
      imageEl.classList.remove('prd-Media_Item-hide')
      imageEl.classList.add('prd-Media_Item-show')
    })

    this.els.trigger?.element.classList.add('prd-Media_LoadButton-hide')
  }
}

if (!customElements.get('load-images')) {
  customElements.define('load-images', LoadImages)
}
